import HttpException from './HttpException';

export default class UnauthorizedHttpException extends HttpException {
    name = 'UnauthorizedHttpException';

    constructor(response: Response, message?: string) {
        super(response, message ?? 'Exceptions.services.http.unauthorized');
    }
}
